<template>
	<b-container class="animated fadeIn pt-2 posContainer" fluid>
		<div class="d-flex justify-content-between mb-1 hidden-print">
			<h5
				class="modal-title d-flex align-items-center"
				v-for="(rate, index) in lastCurrencyRates"
				:class="index === 0 ? 'ml-1' : index === lastCurrencyRates.length - 1 ? 'mr-1' : ''"
				:key="`cbu_currency_rates-pos-top-${index}`"
			>
                <span v-if="rate.currencyCode === 'USD'" class="flag-icon flag-icon-us"></span>
				<span v-else-if="rate.currencyCode === 'EUR'" class="d-inline-flex">
                    <img :src="`${publicPath}img/eunion.png`" alt="europian union flag" style="width: 1.5rem;">
                </span>
				<span v-else-if="rate.currencyCode === 'RUB'" class="flag-icon flag-icon-ru"></span>
				<span v-else-if="rate.currencyCode === 'GBP'" class="flag-icon flag-icon-gb"></span>
				<span v-else-if="rate.currencyCode === 'UZS'" class="flag-icon flag-icon-uz"></span>
				<!--							CURRENCY NAME								-->
				<span class="ml-1">
                    {{ rate.currencyName }} (<b style="color: orange;">{{ rate.ratioToDepCurrencyRate }}</b>) = <b>{{ rate.rate }}</b> (<span :style="rate.difference >= 0 ? {'color': 'green'} : {'color': 'red'}" style="font-size: .95rem;">{{ rate.difference }}<i :class="`fa fa-arrow-circle-o-${rate.difference >= 0 ? 'up' : 'down'} ml-1`"></i></span>)
                </span>

			</h5>
		</div>

		<b-row class="posRow hidden-print">
			<!-- LEFT PART: POS TERMINAL -->
			<b-col
				cols="9"
				id="pos-col-left"
				class="pr-0"
			>

				<!-- CARD-FOR-POS CHILD COMPONENT -->
				<card-for-pos
					:suspend-active="suspendActive"
					:header-title="'DUTY-FREE - ' + shopName + ' (' + shopAddress + ') '"
					:sale-number="currentSaleNumber"
					:cashbox-name="cashboxNumber"
					@searchBarFocus="focusSearchBar"
					@saveSuspend="saveSuspend"
					@createDraftAndFocus="createDraftAndFocus"
					@changeSuspendActive="changeSuspendActive"
					@newPosOpened="focusSearchBar"
				>
					<!-- THIS GOES INSIDE DEFAULT SLOT -->
					<b-col>
						<form @submit="e => e.preventDefault()">
							<div v-click-outside="hideSearchResult">
								<b-input-group>
									<b-input-group-text
										slot="prepend"
										:style="[isReturn ? {'border-color': 'red'} : {}]"
									>
                                        <span class="input-group-addon">
                                            <i class="fa fa-barcode"></i>
                                        </span>
									</b-input-group-text>
									<b-form-input
										class="form-control mousetrap ui-autocomplete-input"
										id="search_product"
										ref="searchBar"
										:placeholder="isReturn ? $t('pos.search-item-return') : $t('pos.search-item')"
										autofocus=""
										@keyup.enter="filterChanged($event.target.value)"
										@input.native="searchTextChanged"
										v-model="posSearchValue"
										onClick="setSelectionRange(0, value.length)"
										name="search_product"
										type="text"
										autocomplete="off"
										:style="[isReturn ? {'border-color': 'red'} : {}]"
									></b-form-input>

									<!-- PRODUCT SEARCH RESULT -->
									<div
										id="searchResult"
										ref="searchResult"
										:style="[getItems.length > 0 ? {'min-height': 'unset'} : {}]"
									>
										<div v-if="searchLoading">
											<loading
												width="60px"
												height="60px"
											></loading>
										</div>
										<with-keyboard-control-for-pos
											:listLength="getItems.length"
											v-if="getItems.length > 0 && !searchLoading"
											@selected="selectedHandler"
											@escapeClicked="escapeClicked"
											:current-index="computedCurrentIndex"
											ref="withKeyboardControl"
										>
											<template slot-scope="{selectedIndex}">
												<!--												<loading
																									v-if="searchLoading"
																									width="60px"
																									height="60px"
																								></loading>-->


												<div
													v-for="(item, index) in getItems"
													class="d-flex justify-content-between foundProduct align-items-center"
													:class="{'selected': index === selectedIndex, 'disabled': (item.qty <= 0 || !item.qty || item.priceUzs <= 0) && !isReturn}"
													:key="'searchItem' + index"
													:style="[item.isPriceDifferent ? {'background-color': '#fff7ae'} : {}]"
													@click="selectedHandler(index)"
												>
													<template>
														<div class="productName mb-0 d-flex">
															<div>
																{{ index + 1 }}.
															</div>
															<div>
																<img
																	class="posItemImage"
																	:src="item.mainPhotoId ? imageUrl + item.mainPhotoId : `${publicPath}img/pos-images/default-thumbnail.jpg`"
																	alt="itemImage"
																>
															</div>
															<div>
                                                                <span>
                                                                    {{ item.name ? item.name : '' }} / <b>{{ item.barcode ? item.barcode : '' }}</b><br><b>{{ item.termOfItem }}</b>
                                                                </span>
															</div>

														</div>
													</template>

													<template>
														<div class="productPrice">
															<p>
																<strong>Цена:</strong>
																<span
																	:style="[item.priceUzs < 0 ? {'color': 'red'} : {'color': 'green'}]">
                                                                    {{
																		item.priceUzs | currency({
																			symbol:
																			userDepCurrencyName,
																			fractionCount: 2,
																			symbolPosition: 'back'
																		})
																	}}
                                                                </span>
																<template v-if="item.incomeDates">
                                                                    <span
																		id="incomeDateOfItem"
																		v-if="item.isPriceDifferent && item.incomeDates.length > 0"
																		:title="makeTooltipForPrice(item.incomeDates)"
																	>
                                                                        <strong>
                                                                            <i>{{
																					item.incomeDates.length > 1 ? item.incomeDates[item.incomeDates.length - 1].substring(0, 7) + '(' + item.incomeDates.length + ')' : item.incomeDates[0].substring(0, 7)
																				}}</i>
                                                                        </strong>
                                                                    </span>
																</template>
															</p>
															<p>
																<strong>{{ $t('sale.kol-vo') }}:</strong>
																<span
																	:style="[item.qty > 0 ? {'color': 'blue'} : {'color': 'red'}]">
                                                                    {{
																		item.qty ? item.qty : 0
																	}} {{ item.unitName ? item.unitName : 'шт.' }}
                                                                </span>
															</p>
														</div>
														<p class="productBreadcrumb">
															{{ item.subCategoryName }} / {{ item.sub2CategoryName }} /
															{{
																item.sub3CategoryName
															}} / <strong>{{ item.genderName }}</strong>
														</p>
													</template>
												</div>
											</template>
										</with-keyboard-control-for-pos>
										<p
											v-if="getItems.length == 0 && !searchLoading"
											style="padding: 10px;"
										>
											{{ $t('warehouse.document.itemNotFound') }}
										</p>
									</div>
									<b-input-group-text slot="append" v-b-toggle.keyboard-search>
										<b-input-group-addon style="cursor: pointer;">
											<i class="fa fa-keyboard-o"/>
										</b-input-group-addon>
									</b-input-group-text>
									<b-input-group-text
										slot="append"
										id="for-barcode"
										:style="[isReturn ? {'border-color': 'red', 'cursor': 'pointer'} : {'cursor': 'pointer'}]"
									>
										<b-input-group-addon
											style="cursor: pointer;"
											class="input-group-addon barcode-refresh"
											@click="searchBarRefresh"
										>
											<i class="fa fa-refresh"></i>
										</b-input-group-addon>
									</b-input-group-text>

								</b-input-group>
								<b-collapse id="keyboard-search" class="mt-2">
									<b-row class="px-3">
										<b-col align="center">
											<b-button @click="posSearchInsert('1')" class="mx-2" variant="outline-primary" pill>1</b-button>
											<b-button @click="posSearchInsert('2')" class="mx-2" variant="outline-primary" pill>2</b-button>
											<b-button @click="posSearchInsert('3')" class="mx-2" variant="outline-primary" pill>3</b-button>
											<b-button @click="posSearchInsert('4')" class="mx-2" variant="outline-primary" pill>4</b-button>
											<b-button @click="posSearchInsert('5')" class="mx-2" variant="outline-primary" pill>5</b-button>
											<b-button @click="posSearchInsert('6')" class="mx-2" variant="outline-primary" pill>6</b-button>
											<b-button @click="posSearchInsert('7')" class="mx-2" variant="outline-primary" pill>7</b-button>
											<b-button @click="posSearchInsert('8')" class="mx-2" variant="outline-primary" pill>8</b-button>
											<b-button @click="posSearchInsert('9')" class="mx-2" variant="outline-primary" pill>9</b-button>
											<b-button @click="posSearchInsert('0')" class="mx-2" variant="outline-primary" pill>0</b-button>
											<b-button @click="posSearchTrash()" class="mx-2" variant="outline-primary" pill><=</b-button>
										</b-col>
									</b-row>
									<b-row class="px-3 mt-2">
										<b-col v-if="shift" align="center">
											<b-button @click="posSearchInsert('Q')" class="mx-2" variant="outline-primary" pill>Q</b-button>
											<b-button @click="posSearchInsert('W')" class="mx-2" variant="outline-primary" pill>W</b-button>
											<b-button @click="posSearchInsert('E')" class="mx-2" variant="outline-primary" pill>E</b-button>
											<b-button @click="posSearchInsert('R')" class="mx-2" variant="outline-primary" pill>R</b-button>
											<b-button @click="posSearchInsert('T')" class="mx-2" variant="outline-primary" pill>T</b-button>
											<b-button @click="posSearchInsert('Y')" class="mx-2" variant="outline-primary" pill>Y</b-button>
											<b-button @click="posSearchInsert('U')" class="mx-2" variant="outline-primary" pill>U</b-button>
											<b-button @click="posSearchInsert('I')" class="mx-2-2" variant="outline-primary" pill>I</b-button>
											<b-button @click="posSearchInsert('O')" class="mx-2" variant="outline-primary" pill>O</b-button>
											<b-button @click="posSearchInsert('P')" class="mx-2" variant="outline-primary" pill>P</b-button>
											<b-button @click="filterChanged(posSearchValue)" class="mx-2" variant="outline-primary" pill>Enter</b-button>
										</b-col>
										<b-col v-else align="center">
											<b-button @click="posSearchInsert('q')" class="mx-2" variant="outline-primary" pill>q</b-button>
											<b-button @click="posSearchInsert('w')" class="mx-2" variant="outline-primary" pill>w</b-button>
											<b-button @click="posSearchInsert('e')" class="mx-2" variant="outline-primary" pill>e</b-button>
											<b-button @click="posSearchInsert('r')" class="mx-2" variant="outline-primary" pill>r</b-button>
											<b-button @click="posSearchInsert('t')" class="mx-2" variant="outline-primary" pill>t</b-button>
											<b-button @click="posSearchInsert('y')" class="mx-2" variant="outline-primary" pill>y</b-button>
											<b-button @click="posSearchInsert('u')" class="mx-2" variant="outline-primary" pill>u</b-button>
											<b-button @click="posSearchInsert('i')" class="mx-2-2" variant="outline-primary" pill>i</b-button>
											<b-button @click="posSearchInsert('o')" class="mx-2" variant="outline-primary" pill>o</b-button>
											<b-button @click="posSearchInsert('p')" class="mx-2" variant="outline-primary" pill>p</b-button>
											<b-button @click="filterChanged(posSearchValue)" class="mx-2" variant="outline-primary" pill>Enter</b-button>
										</b-col>
									</b-row>
									<b-row class="px-3 mt-2">
										<b-col v-if="shift" align="center">
											<b-button @click="posSearchInsert('A')" class="mx-2" variant="outline-primary" pill>A</b-button>
											<b-button @click="posSearchInsert('S')" class="mx-2" variant="outline-primary" pill>S</b-button>
											<b-button @click="posSearchInsert('D')" class="mx-2" variant="outline-primary" pill>D</b-button>
											<b-button @click="posSearchInsert('F')" class="mx-2" variant="outline-primary" pill>F</b-button>
											<b-button @click="posSearchInsert('G')" class="mx-2" variant="outline-primary" pill>G</b-button>
											<b-button @click="posSearchInsert('H')" class="mx-2" variant="outline-primary" pill>H</b-button>
											<b-button @click="posSearchInsert('J')" class="mx-2" variant="outline-primary" pill>J</b-button>
											<b-button @click="posSearchInsert('K')" class="mx-2" variant="outline-primary" pill>K</b-button>
											<b-button @click="posSearchInsert('L')" class="mx-2" variant="outline-primary" pill>L</b-button>
											<b-button class="mx-2" variant="outline-primary" pill @click="shift = false">Shift</b-button>
										</b-col>
										<b-col v-else align="center">
											<b-button @click="posSearchInsert('a')" class="mx-2" variant="outline-primary" pill>a</b-button>
											<b-button @click="posSearchInsert('s')" class="mx-2" variant="outline-primary" pill>s</b-button>
											<b-button @click="posSearchInsert('d')" class="mx-2" variant="outline-primary" pill>d</b-button>
											<b-button @click="posSearchInsert('f')" class="mx-2" variant="outline-primary" pill>f</b-button>
											<b-button @click="posSearchInsert('g')" class="mx-2" variant="outline-primary" pill>g</b-button>
											<b-button @click="posSearchInsert('h')" class="mx-2" variant="outline-primary" pill>h</b-button>
											<b-button @click="posSearchInsert('j')" class="mx-2" variant="outline-primary" pill>j</b-button>
											<b-button @click="posSearchInsert('k')" class="mx-2" variant="outline-primary" pill>k</b-button>
											<b-button @click="posSearchInsert('l')" class="mx-2" variant="outline-primary" pill>l</b-button>
											<b-button class="mx-2" variant="outline-primary" pill @click="shift = true">Shift</b-button>
										</b-col>
									</b-row>
									<b-row class="px-3 mt-2">
										<b-col v-if="shift" align="center">
											<b-button @click="posSearchInsert('Z')" class="mx-2" variant="outline-primary" pill>Z</b-button>
											<b-button @click="posSearchInsert('X')" class="mx-2" variant="outline-primary" pill>X</b-button>
											<b-button @click="posSearchInsert('C')" class="mx-2" variant="outline-primary" pill>C</b-button>
											<b-button @click="posSearchInsert('V')" class="mx-2" variant="outline-primary" pill>V</b-button>
											<b-button @click="posSearchInsert('B')" class="mx-2" variant="outline-primary" pill>B</b-button>
											<b-button @click="posSearchInsert('N')" class="mx-2" variant="outline-primary" pill>N</b-button>
											<b-button @click="posSearchInsert('M')" class="mx-2" variant="outline-primary" pill>M</b-button>
											<b-button @click="posSearchInsert(' ')" class="mx-2" variant="outline-primary" pill>___________</b-button>
											<b-button @click="posSearchInsert(',')" class="mx-2" variant="outline-primary" pill>,</b-button>
										</b-col>
										<b-col v-else align="center">
											<b-button @click="posSearchInsert('z')" class="mx-2" variant="outline-primary" pill>z</b-button>
											<b-button @click="posSearchInsert('x')" class="mx-2" variant="outline-primary" pill>x</b-button>
											<b-button @click="posSearchInsert('c')" class="mx-2" variant="outline-primary" pill>c</b-button>
											<b-button @click="posSearchInsert('v')" class="mx-2" variant="outline-primary" pill>v</b-button>
											<b-button @click="posSearchInsert('b')" class="mx-2" variant="outline-primary" pill>b</b-button>
											<b-button @click="posSearchInsert('n')" class="mx-2" variant="outline-primary" pill>n</b-button>
											<b-button @click="posSearchInsert('m')" class="mx-2" variant="outline-primary" pill>m</b-button>
											<b-button @click="posSearchInsert(' ')" class="mx-2" variant="outline-primary" pill>___________</b-button>
											<b-button @click="posSearchInsert('.')" class="mx-2" variant="outline-primary" pill>.</b-button>
										</b-col>
									</b-row>
								</b-collapse>
							</div>
						</form>
					</b-col>
					<!-- THIS GOES INSIDE ITEMS SLOT -->
					<template v-slot:items>
						<b-col>
							<div id="posProducts">
								<b-table
									small
									hover
									bordered
									striped
									:fields="fields"
									:items="getCartItems"
									class="generalTableClass posProductsTable"
								>
									<template
										slot="number"
										slot-scope="data"
									>
										{{ data.index + 1 }}
									</template>

									<template
										slot="Продукт"
										slot-scope="data"
									>

										{{ data.item.name ? data.item.name : '' }} <br><strong>{{ data.item.termOfItem }}</strong>
									</template>

									<template
										slot="quantity"
										slot-scope="data"
									>
										<b-input-group
											size="sm"
											class="posQtyButton"
										>
											<b-input-group-prepend>
												<b-button
													variant="secondary"
													size="sm"
													@click="decreaseQty(data.index)"
													:disabled="isCountBtnsDisabled || data.item._rowVariant === 'warning'"
												>
													-
												</b-button>
											</b-input-group-prepend>

											<b-form-input
												type="number"
												min="1"
												autocomplete="off"
												:value="getCountOfItem(data.index)"
												@input="setCount($event, data.index)"
												@keyup.enter.native="focusSearchBar"
												@focus="$event.target.select()"
												:disabled="data.item._rowVariant === 'warning'"
											></b-form-input>

											<b-input-group-append>
												<b-button
													variant="success"
													size="sm"
													@click="increaseQty(data.index)"
													:disabled="isCountBtnsDisabled || data.item._rowVariant === 'warning'"
												>
													+
												</b-button>
											</b-input-group-append>
										</b-input-group>
<!--										<span v-else> {{ data.item.count }}</span>-->
										<!-- OMBORDAGI QOLDIQDAN KO'P KIRITVORSA CHIQADI BU YOZUV -->
										<p
											v-if="getCountOfItem(data.index) > data.item.qty && !data.item._rowVariant"
											style="color: red;"
										>
											Доступно только {{ data.item.qty }} {{
												data.item.unitName ?
													data.item.unitName : 'шт.'
											}}
										</p>
									</template>

									<template
										slot="priceUzs"
										slot-scope="data"
									>
										{{
											data.item.priceUzs | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition: 'back'
											})
										}}
									</template>

									<template
										slot="pul"
										slot-scope="data"
									>
										{{
											afterPromotionSum(data.item) | currency({
												symbol:
												userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
											})
										}}
									</template>
									<template
										slot="percentage"
										slot-scope="data"
									>
										{{
											afterPromotionPercentage(data.item) | currency({
												symbol:
													'%', symbolPosition: 'back'
											})
										}}
									</template>
									<template
										slot="discountPriceUzs"
										slot-scope="data"
									>
										{{
											data.item.discountPriceUzs | currency({
												symbol: userDepCurrencyName, fractionCount: 2, symbolPosition:
													'back'
											})
										}}
									</template>

									<template
										slot="subtotal"
										slot-scope="data"
									>
										{{
											data.item.discountPriceUzs * data.item.count | currency({
												symbol:
												userDepCurrencyName, fractionCount: 2,
												symbolPosition: 'back'
											})
										}}
									</template>

									<template
										slot="inventoryQty"
										slot-scope="data"
									>
										{{ data.item.qty }} {{ data.item.unitName ? data.item.unitName : 'шт.' }}
									</template>

									<template
										slot="actions"
										slot-scope="data"
									>
										<b-link
											:key="data.item.id + 'delete'"
											@click="deleteFromCart(data.index)"
											class="text-center"
											style="margin: 10px; font-size: 15px"
										>
											<i class="fa fa-trash text-center ml-1 text-danger"></i>
										</b-link>
										<!--                                        <b-link-->
										<!--                                            :key="data.item.id + 'update'"-->
										<!--                                            @click="openItemForDiscount(data, data.index)"-->
										<!--                                        >-->
										<!--                                            <i class="fa fa-pencil-square-o cursor-pointer"></i>-->
										<!--                                        </b-link>-->
									</template>

									<!-- skidka tovarlar -->
								</b-table>
							</div>
						</b-col>
						<b-modal
							:title="$t('pos.discountItems')"
							ref="balanceItemsRef"
							ok-only
						>
							<p
								v-for="(el, index) in balanceItems"
								:key="`balance-item-${index}`"
							>
                                <span v-if="el._rowVariant == 'warning'">
                                    <b>{{ index + 1 }}.</b> {{ el.name }}/{{ el.barcode }}/
                                    <b style="color: red;">{{ $t('pos.inventoryQty') }} {{ el.qty }}</b>
                                    <br>
                                </span>
							</p>
						</b-modal>
						<!--<b-modal  ref="ostatkaTovar" ok-only>-->
						<!--<p>Ostatka: 0</p>-->
						<!--</b-modal>-->
						<!-- OVERALL AND BUTTONS PART -->
						<b-col style="position:absolute; bottom: 0;">
							<div id="overallAndButtons">
								<table class="table table-condensed posFooterTable">
									<tbody>
									<tr>
										<td
											style="display: flex; align-items: center;"
											class="pl-3"
										>
											<b-col class="d-inline-table" cols="2">
												<b>{{ $t('sale.products') }}: </b> <br>
												<span>{{ totalCount }}</span>
											</b-col>
											<b-col class="d-inline-table mr-4" cols="2">
												<b>{{ $t('pos.no-skidka') }} : </b> <br>
												<span>{{setBezSkidkaSum | currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</span>
											</b-col>
											<b-col class="d-inline-table" cols="2">
												<b>{{ $t('pos.sum') }}: </b> <br>
												<span>{{setTotalSum | currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</span>
											</b-col>
<!--											<b-col class="d-inline-table" col sm="2" xs="2" v-if="savdoType === 'isDona'">-->
												<!--                                                    <b>{{ $t('pos.no-check') }}(-): </b> <br>-->
												<!--                                                    <i-->
												<!--                                                        @click="openItemForDiscountGeneral"-->
												<!--                                                        style="padding-right: 5px"-->
												<!--                                                        class="fa fa-pencil-square-o cursor-pointer"-->
												<!--                                                        id="pos-edit-discount"-->
												<!--                                                        title="Edit Discount"-->
												<!--                                                        aria-hidden="true"-->
												<!--                                                        data-toggle="modal"-->
												<!--                                                        data-target="#posEditDiscountModal"-->
												<!--                                                    ></i>-->
												<!--                                                    <span v-if="customPromotion">-->
												<!--                                                        {{ customPromotion.discount }}-->
												<!--                                                        <span v-if="customPromotion.promotionType == '%'">{{-->
												<!--															customPromotion.promotionType-->
												<!--														}}</span>-->
												<!--                                                        <span v-else>{{ userDepCurrencyName }}</span>-->
												<!--                                                    </span>-->
												<!--                                                    <span v-else>{{-->
												<!--														0 | currency({-->
												<!--															symbol: '',-->
												<!--															symbolPosition: 'back', thousandsSeparator: ''-->
												<!--														})-->
												<!--													}}</span>-->
<!--											</b-col>-->
<!--											<b-col class="d-inline-table" col sm="2" xs="2" v-if="savdoType ==='isOptom'">-->
<!--												<b>Оптом скидка(-): </b> <br>-->
<!--												<i @click="openModalForOptomDiscount" style="padding-right: 5px" class="fa fa-pencil-square-o cursor-pointer" id="pos-edit-optom-discount" title="Edit Discount" aria-hidden="true" data-toggle="modal"></i>-->
<!--												<span>{{ discountOptom !== null ? discountOptom : "0.00" }}</span>-->
<!--											</b-col>-->
											<!--<b-col class="d-inline-table" col sm="2" xs="2">
											<b>Member Card Discount(-): </b> <br>
											<span
												v-if="getFromModalMemberCard.memberCardDiscount">{{ getFromModalMemberCard.memberCardDiscount
												}}</span>
											<span
												v-else-if="getCurrentClient.memberCardDiscount">{{ getCurrentClient.memberCardDiscount
												}}</span>
											<span v-else>0</span>
										</b-col>-->
											<!--				promotion_type							<b-col class="d-inline-table" col sm="2" xs="3">-->
											<!--												<b>Order Tax(+): </b> <br>-->
											<!--												<span>0</span>-->
											<!--											</b-col>-->
											<!--											<b-col class="d-inline-table" col sm="2" xs="3">-->
											<!--												<b>Shipping(+): </b> <br>-->
											<!--												<span>0</span>-->
											<!--											</b-col>-->
											<b-col class="d-inline-table" cols="3">
												<div class="lastElemet">
													<div>
														<b>{{ $t('pos.finalTotalSum') }}: </b> <br>
														<strong style="color: green;font-size: 14px">{{finalTotalSum | currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</strong>
													</div>
												</div>
											</b-col>
											<b-col class="d-inline-table">
												<div class="d-flex justify-content-end mr-2">
													<b-button variant="danger" style="padding: 4px 8px; font-size: 14px;" @click="cancelClicked">
														{{ $t('cancel') }}
													</b-button>
												</div>
											</b-col>
										</td>
									</tr>
									<tr>
										<td id="posButtons">
											<div class="d-flex align-items-center col-9" style="height: 50px">
<!--												<div class="col-4 pl-0">-->
<!--													<b-input-group>-->
<!--														<b-form-textarea-->
<!--															style="height: 50px;"-->
<!--															id="textarea"-->
<!--															:value="comment"-->
<!--															@input="commentForSuspend"-->
<!--															:placeholder="$t('comment')"-->
<!--															rows="3"-->
<!--															max-rows="6"-->
<!--														></b-form-textarea>-->
<!--													</b-input-group>-->
<!--												</div>-->
												<b-col class="d-inline-table">
													<b-button variant="warning" @click="saveSuspend" style="width: 50px; height: 50px">
														<i class="fa fa-pause"></i>
													</b-button>
												</b-col>
											</div>
											<!--<b-col class="d-inline-table" col sm="2" xs="2">
											<b-button variant="dark"
													  style="width: 92%; height: 50px"
											>
												Перечисления
											</b-button>
										</b-col>
										<b-col class="d-inline-table" col sm="2" xs="2">
											<b-button variant="info"
													  style="width: 92%; height: 50px"
											>
												Карта
											</b-button>
										</b-col>-->
											<b-col class="d-inline-table" col sm="3" xs="3">
												<b-button
													@click="multiplePayment"
													variant="success"
													ref="paymentButton"
													style="width: 95%; height: 50px; font-size: 24px;"
												>
													{{ $t('pos.payment') }}
												</b-button>
												<b-modal
													hide-footer
													hide-header
													ref="multiPayModal"
													centered
													id="posPaymentModal"
												>
													<div
														slot="modal-header"
														class="posCustomModalHeader"
													>
														<h1 class="modal-title">Оплата</h1>
														<!--						FINISH ERROR								-->
														<span
															v-if="saleFinishError"
															class="modal-title"
														>{{ saleFinishError }}</span>
														<!--						SPINNER (LOADER)								-->
														<b-spinner
															v-if="saleFinishLoading"
															small
															variant="primary"
															label="Small Spinner"
														></b-spinner>
														<!--														<button class="modal-actions">button</button>-->
														<div class="posModalActions d-flex">
															<!--<button
															type="button"
															class="minimize close"
															@click="minimizePayment"
														>
															&lt;!&ndash;																<span aria-hidden="true">-</span>&ndash;&gt;
															<i class="fa fa-window-minimize"></i>
														</button>-->
															<button
																type="button"
																class="close"
																data-dismiss="modal"
																aria-label="Close"
																@click="closePayment"
															>
																<!--																<span aria-hidden="true">&times;</span>-->
																<i class="fa fa-times"></i>
															</button>
														</div>
													</div>
													<div class="text-center text-danger font-2xl">{{ saleErrorMessage }}</div>
													<!-- MULTIPLE PAYMENT COMPONENT BEGIN -->
													<multiple-pay
														ref="multiplePayRef"
														:totalCount="totalCount"
														:totalSum="finalTotalSum"
														:openClicked="openClicked"
														:last-currency-rates="lastCurrencyRates"
														@close="closePayment"
														@success="successMultiPay"
														@hidden="focusSearchBar"
													>
													</multiple-pay>
													<!-- MULTIPLE PAYMENT COMPONENT END -->
												</b-modal>

											</b-col>

										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</b-col>
					</template>
				</card-for-pos>
			</b-col>

			<!-- RIGHT PART: TRANSACTION -->
			<client-for-pos
				@searchBarFocus="focusSearchBar('clientForPos')"
				@changeSuspendActive="changeSuspendActive"
				@showZReport="showConfirmEndSession"
				@showXReport="showXReport"
				@show="showZReport"
				@saveSuccess="savePos('draft')"
				@savdoTypeChanged="savdoTypeChanged"
				@oneTimeDiscountClicked="oneTimeDiscountClickHandler"
				:countOfOneTimeDiscount="countOfOneTimeDiscount"
				ref="clientForPos"
			>

			</client-for-pos>

			<b-modal
				hide-footer
				v-model="discountOpenModal"
				@shown="focusMyDiscount"
				:title='discountTForTitle? `Скидка на ${saleItemForDiscountModal.item.name}`: "Скидка на чек"'
			>
				<pos-discount
					@emitClose="closeEmit"
					@saveSuccess="savePos('draft')"
					:itemIndex="currentItemIndex"
					ref="posDiscount"
				></pos-discount>
			</b-modal>
			<b-modal
				hide-footer
				v-model="discountOptomOpenModal"
				@shown="focusMyOptomDiscount"
				:title='`Оптом скидка`'
			>
				<pos-discount-optom
					@emitClose="closeOptomDiscount"
					@saveSuccess="saveOptomDiscount"
					ref="posOptomDiscount"
					:canceled="getCartItems.length === 0 || discountOptom === null"
				></pos-discount-optom>
			</b-modal>

			<!-- Z-REPORT OPEN MODAL -->
			<b-modal
				size="md"
				hide-footer
				ref="sessionStart"
				id="sessionStart"
				:no-close-on-esc="true"
				:no-close-on-backdrop="true"
				@shown="focusEnterCode"
			>
				<div
					slot="modal-header"
					class="d-flex justify-content-start align-items-center"
				>
					<b-link
						to="/"
						variant="outline-dark"
						class="mr-3"
						v-b-tooltip.hover
						:title="$t('sidebar.dashboard')"
					>
						<i
							class="fa fa-home"
							style="font-size: 18px;"
						></i>
					</b-link>
					<h1 class="modal-title">{{ $t('session-start') }}: {{ $t('roles.code') }} 12345</h1>
				</div>
				<h3
					v-if="sessionStart.isFail"
					class="text-danger"
				>{{ sessionStart.message }}</h3>

				<b-form-group
					:state="sessionStart.codeState"
					:label="$t('roles.code')"
					label-for="name-input"
					:invalid-feedback="sessionStart.invalidMessage"
				>
					<b-form-input
						ref="enterConfirmCode"
						size="md"
						autocomplete="off"
						class="form-control mousetrap ui-autocomplete-input"
						id="name-input"
						v-model="sessionStart.code"
						required
					></b-form-input>
				</b-form-group>

				<b-button block size="lg" variant="primary" type="submit" @click="checkZReport">Ok</b-button>

			</b-modal>
			<!--			<b-modal v-model="confirmEndSession" hide-footer hide-header centered>-->

			<!--				<div class="d-block text-center">-->
			<!--					<h3>Are you sure?</h3>-->
			<!--					<br>-->
			<!--				</div>-->
			<!--				<div>-->
			<!--					<b-button variant="outline-danger" size="sm" block-->
			<!--							  @click.prevent="confirmEndSession = !confirmEndSession">-->
			<!--						{{$t('actions.no')}}-->
			<!--					</b-button>-->
			<!--					<b-button variant="outline-success" size="sm" block @click="showZReport">-->
			<!--						{{$t('actions.yes')}}-->
			<!--					</b-button>-->
			<!--				</div>-->

			<!--			</b-modal>-->
			<b-modal
				v-model="confirmEndSession"
				@ok="closeAndPrintZReport"
				@cancel="confirmEndSession = !confirmEndSession"
				ok-title="Да"
				cancel-title="Отмена"
			>
				<h4>{{ $t('zOtchet.title') }}</h4>
			</b-modal>
			<b-modal
				size="lg"
				hide-footer
				:no-close-on-esc="true"
				:no-close-on-backdrop="true"
				hide-header
				ref="zreport"
				id="zreport"
				class="body-padding-0"
			>
				<!-- ZET REPORT COMPONENT BEGIN -->
				<x-and-z-report
					v-if="zreport"
					is-z-report
					@close="closeZreport"
				></x-and-z-report>
				<!-- ZET REPORT  COMPONENT END -->
			</b-modal>
			<b-modal
				size="lg"
				hide-footer
				hide-header
				:no-close-on-esc="true"
				:no-close-on-backdrop="true"
				ref="xreport"
				id="xreport"
				class="body-padding-0"
			>
				<!-- ZET REPORT COMPONENT BEGIN -->
				<x-and-z-report
					v-if="xreport"
					@close="closeXreport"
				></x-and-z-report>
				<!-- ZET REPORT  COMPONENT END -->
			</b-modal>
		</b-row>

		<!-- CHECK TO PRINT BEGIN -->
		<div
			class="print section-to-print"
			id="posCheckClone"
		>
			<div
				id="depNameClone"
				class="d-flex justify-content-center"
			><strong>DUTY-FREE - {{ shopName }}</strong>
			</div>
			<div
				id="depAddressClone"
				class="d-flex justify-content-center bottom-bordered"
			><i>{{ shopAddress }}</i>
			</div>
			<div class="d-flex justify-content-between"><span>{{ dateTime }}</span> <span
				style="text-align: right;">{{ $t('sidebar.pos.check') }}: {{
					currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber
				}}</span>
			</div>
			<div class="d-flex justify-content-between"><span>{{ $t('xAtchot.cashier') }}:{{ cashierFullName }}</span>
				<span style="text-align: right;">POS №:{{ cashboxNumber }}</span>
			</div>
			<div
				class="d-flex justify-content-between"
				:class="returnItemsCount == 0 ? 'bottom-bordered' : ''"
			><span>{{ $t('pos.saller') }}:{{ currentSellerName }}</span>
				<span style="text-align: right;">{{ $t('pos.items') }}:{{ totalCount }}</span>
			</div>
			<div
				v-if="returnItemsCount !== 0"
				class="d-flex justify-content-end bottom-bordered"
			>
				<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
			</div>
			<div class="posCheckTable bottom-bordered">
				<table>
					<thead>
					<tr>
						<th
							class="alignedLeft"
							style="width: 45%; word-break: break-all;"
						>{{ $t('sale.products') }}
						</th>
						<th
							class="alignedCenter"
							style="width: 17%; word-break: break-all;"
						>{{ $t('sale.kol-vo') }}
						</th>
						<th
							class="alignedCenter"
							style="width: 17%; word-break: break-all;"
						>
							{{ $t('sidebar.pos.sale') }}
						</th>
						<th
							class="alignedRight"
							style="width: 32%; word-break: break-all;"
						>
							{{ $t('incomes.create.price') }} ({{ userDepCurrencyName }})
						</th>
					</tr>
					</thead>
					<tbody>
					<tr
						v-for="(item, index) in getCartItems"
						:key="'checkItem' + index"
						:class="item.count < 0 ? 'returnItemBordered' : ''"
					>
						<td
							class="alignedLeft"
							style="width: 45%; word-break: break-all;"
						>
							<strong>{{ index + 1 }}.</strong>{{ item.name }}/<strong>{{ item.artikul }}</strong>/{{
								item.genderName
							}}/{{
								item.colorName
							}}/<strong>{{ item.size }}</strong>
						</td>
						<td
							class="alignedCenter"
							style="width: 17%; word-break: break-all;"
						>
							{{ item.count > 0 ? item.count : -item.count }}
						</td>
						<td
							class="alignedCenter"
							style="width: 17%; word-break: break-all;"
						>
							<template v-if="afterPromotionSum(item) > 0">
								{{
									afterPromotionSum(item) | currency({
										symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
									})
								}}
							</template>
							<template v-else-if="afterPromotionPercentage(item) > 0">
								{{
									afterPromotionPercentage(item) | currency({
										symbol: '%', symbolPosition: 'back'
									})
								}}
							</template>
							<template v-else> -</template>
						</td>
						<td
							class="alignedRight"
							style="width: 32%; word-break: break-all;"
						>
							{{
								item.discountPriceUzs * item.count | currency({
									symbol: '', fractionCount: 2, symbolPosition:
										'back',
									thousandsSeparator: ''
								})
							}}<br>{{
								item.priceUzs * item.count | currency({
									symbol: '',
									fractionCount: 2,
									symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="posCheckTotal bottom-bordered">
				<table>
					<tbody>
					<tr>
						<td class="alignedLeft">{{ $t('warehouse.table.totalIncomeUzs') }}</td>
						<td class="alignedRight">{{
								finalTotalSum | currency({
									symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{ $t('pos.ndc') }}</td>
						<td class="alignedRight">{{
								finalTotalSum / 6 | currency({
									symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{ $t('xAtchot.pay') }}</td>
						<td class="alignedRight">{{
								finalTotalSum | currency({
									symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{ $t('sale.payed') }}</td>
						<td class="alignedRight">{{
								totalPaid | currency({
									symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr
						v-if="returnItemsSum !== 0"
						class="returnItemBordered"
					>
						<td class="alignedLeft">ВОЗВРАТ</td>
						<td class="alignedRight">{{
								-returnItemsSum | currency({
									symbol: userDepCurrencyName, fractionCount: 2,
									symbolPosition:
										'back', thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr
						v-if="parseInt(sponsorshipAmount) > 0"
						class="returnItemBordered"
					>
						<td class="alignedLeft">{{ $t('sidebar.sales.sponsor') }}</td>
						<td class="alignedRight">{{
								sponsorshipAmount | currency({
									symbol: userDepCurrencyName,
									fractionCount: 2,
									symbolPosition:
										'back', thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr v-if="parseInt(debtPayment) > 0">
						<td class="alignedLeft">ДОЛГ</td>
						<td class="alignedRight">{{
								debtPayment | currency({
									symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{ $t('pos.no-check') }}</td>
						<td
							class="alignedRight"
							v-if="customPromotion"
						>
							{{ customPromotion.discount }}
							<span v-if="customPromotion.promotionType == '%'">{{ customPromotion.promotionType }}</span>
							<span v-else>{{ userDepCurrencyName }}</span>
						</td>
						<td
							class="alignedRight"
							v-else
						>{{
								0 | currency({
									symbol: '',
									symbolPosition: 'back', thousandsSeparator: ''
								})
							}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<!-- IF ISONLINE PRODAJA CHEKED -->
			<div
				v-if="isOnlaynProdaja"
				class="posCheckTotalB bottom-bordered"
			>
				<table>
					<tbody>
					<tr>
						<td class="alignedLeft">Номер заказа</td>
						<td class="alignedRight">
							{{ orderNumber }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Клиент</td>
						<td class="alignedRight">
							{{ clientName }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Контактный номер</td>
						<td class="alignedRight">
							{{ clientPhoneNumber }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Адрес доставки</td>
						<td class="alignedRight">
							{{ clientAddress }}
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<div class="posThanks">
				<!--<p><i>&#45;&#45; Xaridingiz uchun raxmat! &#45;&#45;      Davlat tili rus tili deb elon qilyapmizuuuuuu  ))))))))</i></p>-->
				<p><i>-- {{ $t('pos.please') }}! --</i></p>
			</div>
		</div>
		<div>
			<b-modal
				:no-close-on-backdrop="true"
				:no-enforce-focus="true"
				:no-fade="true"
				:no-close-on-esc="true"
				v-model="multiBarcodeModalShow"
				hide-footer
				hide-header
				size="sm"
			>
				<b-container class="bv-example-row">
					<b-row v-for="(val, key) in this.selectedItem.multiBarcodes" style="padding: 3%">
						<b-col lg="12">
							<b-button
								variant="light"
								class="btn-block"
								@click="selectMultiBarcode(val)"
							>{{ val.barcode }}
							</b-button>
						</b-col>
					</b-row>
				</b-container>

			</b-modal>
			<!--	ONE TIME DISCOUNT MODAL		-->
			<b-modal
				v-model="oneTimeDiscountModal"
				size="lg"
				hide-footer
				hide-header
			>
				<template>
					<table class="table table-striped" id="whDocTable">
						<thead>
						<tr>
							<th class="p-1"> {{ $t("incomeFilter.regNo") }}</th>
							<th class="p-1"> {{ $t("inventory.startDate") }}</th>
							<th class="p-1"> {{ $t("inventory.finishDate") }}</th>
							<th class="p-1"></th>

						</tr>
						</thead>
						<tbody>
						<tr v-for="(item,index) in oneTimeDiscountDocs">
							<td class="p-1">
								{{ item.regNumber }}
							</td>
							<td class="p-1">
								{{ item.startDiscountDate }}
							</td>
							<td class="p-1">
								{{ item.endDiscountDate }}
							</td>
							<td align="center" class="p-1">
								<b-button
									@click="choseAndCloseOneTimeDiscountModal(item)"
									variant="light">
									<i class="fas fa-upload"></i>
								</b-button>
							</td>
						</tr>
						</tbody>
					</table>

				</template>
			</b-modal>

			<b-modal v-model="zetDateEnd" no-close-on-backdrop>
				<template slot="modal-header" slot-scope="data">
					<b>Срок Z отчета окончено !</b>
				</template>
				<b>Хотите закрыть Z отчет ?</b>
				<template slot="modal-footer" slot-scope="data">
					<b-button @click="closeAndPrintZReport" variant="primary">Да</b-button>
				</template>
			</b-modal>
		</div>
		<!-- CHECK TO PRINT END -->
	</b-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import CurrencyService from "@/services/currency.service";
import ApiService from "@/services/api.service";
import FBoxService from "@/services/fbox.service"
import Vue from 'vue'
import CardForPos from './components/CardForPos'
import MultiplePay from './components/MultiplePayment/MultiplePay'
import ClientForPos from '../ClientForPos'
import Loading from '../../components/Loading'
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import WithKeyboardControlForPos from "./components/WithKeyboardControlForPos";
import {TokenService} from "../../../services/storage.service";
import PosDiscount from "./components/PosDiscount";
import PosDiscountOptom from "./components/PosDiscountOptom"
import WarehouseService from "@/services/wh-document.service";
import SimpleKeyboard from "./SimpleKeyboard";
import ZetReportService from "../../../services/zet-report.service";

export default {
	name: "Pos",

	/** --COMPONENTS-- **/
	components: {
		CardForPos,
		ClientForPos,
		WithKeyboardControlForPos,
		MultiplePay,
		PosDiscount,
		PosDiscountOptom,
		XAndZReport,
		Loading,
		SimpleKeyboard
	},

	/** --DATA-- **/
	data() {
		return {
			saleError: false,
			zetDateEnd: false,
			saleErrorMessage: '',
			shift: false,
			countOfOneTimeDiscount: 0,
			oneTimeDiscountDocs: [],
			oneTimeDiscountDoc: null,
			oneTimeDiscountModal: false,
			isSearchTxtChanged: false,
			lastCurrencyRates: [],
			itemSelectedWithEnter: false,
			publicPath: process.env.BASE_URL,
			currentItemIndex: null,
			barcodeScanned: false,
			isCountBtnsDisabled: false,
			returnMoney: 0,
			returnItemsCount: 0,
			returnItemsSum: 0,
			debtPayment: 0,
			sponsorshipAmount: 0,
			totalPaid: 0,
			cashboxNumber: localStorage.getItem('cash_number'),
			posSearchValue: '',
			dateTime: '',
			discountOpenModal: false,
			discountOptomOpenModal: false,
			openClicked: false,
			checkedClient: {},
			currentClient: null,
			currentIndex: 0,
			objectForCountIncrement: {},
			tempForSale: {
				'action': 'SOTISH',
			},
			localComment: '',
			multiPays: [],
			zreport: false,
			xreport: false,
			timeout: null,
			suspendActive: false,
			message: '',
			discountTForTitle: false,
			totalPayable: 0,
			confirmEndSession: false,
			savdoType: 'isDona',
			contrAgent: null,
			discountOptom: null,
			sessionStart: {
				started: false,
				code: null,
				codeState: null,
				message: 'Ошибка на сервере, пожалуйста, попробуйте чуть позже...',
				invalidMessage: 'Пожалуйста, введите правильный код',
				isFail: false,
			},
			multiBarcodeModalShow: false,
			selectedItem: {},
			multiBarcode: null,
			fields: [
				{
					key: 'number',
					label: '№',
					sortable: true
				},
				{
					key: 'Продукт',
					label: this.$t('pos.product'),
					'class': 'noDefaultButton, width15_wordBreak',
				},

				{
					key: 'quantity',
					label: this.$t('pos.qty'),
					'class': 'noDefaultButton, width15_wordBreak',
				},
				{
					key: 'priceUzs',
					label: this.$t('incomes.create.price')
				},
				{
					key: 'pul',
					label: this.$t('promo-to-product.promo')
				},
				{
					key: 'percentage',
					label: this.$t('promo-to-product.promo') + ' %'
				},
				{
					key: 'discountPriceUzs',
					label: this.$t('pos.promo')
				},

				{
					key: 'subtotal',
					label: this.$t('pos.sum')
				},

				{
					key: 'inventoryQty',
					label: this.$t('pos.inventoryQty'),
					'class': 'textAlignCenter'
				},
				// {
				// 	key: 'delete',
				// 	label: this.$t('goods.actions'),
				// 	'class': 'table_actions'
				// },
				// {
				// 	key: 'update',
				// 	label: this.$t('goods.actions'),
				// 	'class': 'table_actions'
				// },
				{
					key: 'actions',
					label: ''
				}


			]
		}
	},

	/** --COMPUTED-- **/
	computed: {
		...mapGetters('pos', [
			'getItems', 'getCartItems', 'getDiscountItemForModal',
		]),
		...mapState("zetReport", ["currentReport"]),
		...mapState(['isCashier', 'userDepCurrencyName']),
		...mapState('pos', [
			'clientPhoneNumber', 'clientName', 'orderNumber', 'isOnlaynProdaja', 'clientAddress',
			'totalCount', 'totalSum', 'checkPage', 'finalTotalSum', 'realTotalSum', 'comment',
			'shopName', 'currentSaleNumber',
			'currentSaleId', 'balanceItems',
			'shopAddress', 'cashierFullName', 'currentSellerName', 'sellerId',
			'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
			'searchLoading', 'saleFinishError', 'saleFinishLoading',
			'isReturn', 'amountOfPaymentUzs', 'amountOfAfterPromoUzs'
		]),
		...mapGetters('clients', [
			'getFromModalMemberCard', 'getCurrentClient', 'getCurrentClientFromModal'
		]),
		...mapGetters('zetReport', [
			'getCurrentSession', 'getZetReport', 'getReportX'
		]),

		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		},
		/*totalPayablefunction() {
			let memberCardAndGeneralDiscount = 0;
			if (this.getFromModalMemberCard.memberCardDiscount) {
				memberCardAndGeneralDiscount = this.getFromModalMemberCard.memberCardDiscount + this.discount;
			} else if (this.getCurrentClient.memberCardDiscount) {
				memberCardAndGeneralDiscount = this.getFromModalMemberCard.memberCardDiscount + this.discount;
			}
			this.totalPayable = this.totalSum - (this.totalSum * memberCardAndGeneralDiscount) / 100;
			return this.totalPayable;
		},*/
		setTotalSum() {
			let resultSum = 0;
			for (let i = 0; i < this.getCartItems.length; i++) {
				resultSum += this.getCartItems[i].discountPriceUzs * this.getCartItems[i].count;
			}
			return resultSum;
		},
		setBezSkidkaSum() {
			let resultSum1 = 0;
			for (let i = 0; i < this.getCartItems.length; i++) {
				resultSum1 += this.getCartItems[i].priceUzs * this.getCartItems[i].count;

			}
			return resultSum1;

		},
		computedCurrentIndex() {
			return this.currentIndex;
		},
	},

	/** --WATCHERS-- **/
	watch: {
		'balanceItems': {
			handler() {
				this.showBalanceItemsModal()
			}
		},
		/*'getItems': {
			handler () {
				/!*if (this.getItems.length == 0) {
					/!** AGAR RESULTAT TOPILMASA SEARCHBAR VALUESINI SELECT QILIB QO'YSIN (QULAYLIK UCHUN) **!/
					this.$refs.searchBar.$el.setSelectionRange(0, this.$refs.searchBar.$el.value.length);
				}*!/
				this.currentIndex = 0;
			}
		},*/

		// 'sessionStart.code': {
		// 	handler(newValue) {
		// 		if (newValue !== '12345') {
		// 			this.sessionStart.codeState = 'invalid'
		// 		} else {
		// 			this.sessionStartOk()
		// 		}
		// 	}
		// }
	},

	/** --METHODS-- **/
	methods: {
		checkZReport() {
			ZetReportService.checkOpenZReport(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).catch(e => {
				if (e.response.data.message == 1) {
					if (this.sessionStart.code == '12345') {
						this.sessionStartOk()
					} else {
						this.sessionStart.codeState = 'invalid'
					}
				} else {
					this.sessionStart.invalidMessage = e.response.data.message
					this.sessionStart.codeState = 'invalid'
				}
			})
		},
		posSearchInsert(key) {
			this.posSearchValue += key
		},
		posSearchTrash() {
			this.posSearchValue = this.posSearchValue.substring(0, this.posSearchValue.length-1)
		},
		getActiveDiscount() {
			WarehouseService.getActiveDiscount(localStorage.getItem('dep_id')).then(response => {
				this.oneTimeDiscountDocs = response.data
				this.countOfOneTimeDiscount = this.oneTimeDiscountDocs.length
			});
		},
		async choseAndCloseOneTimeDiscountModal(item) {
			this.oneTimeDiscountDoc = item

			this.clearCartItems()

			for (let i = 0; i < item.whItems.length; i++) {
				let saleItem = {
					barcode: null,
					count: null,
					currentDiscounts: [],
					customPromotion: {},
					discountPriceUzs: null,
					isOptom: false,
					itemId: null,
					name: null,
					priceUzs: null,
					promotions: [],
					qty: null,
					wrapped: false,
					unchangeable: true,
					whDocId: null
				}

				saleItem.barcode = item.whItems[i].barcode
				saleItem.count = item.whItems[i].count
				saleItem.discountPriceUzs = item.whItems[i].priceUzs
				saleItem.itemId = item.whItems[i].itemId
				saleItem.priceUzs = item.whItems[i].priceUzs
				saleItem.name = item.whItems[i].itemName
				saleItem.qty = item.whItems[i].count
				saleItem.whDocId = item.whItems[i].documentId

				await this.addToCartAction(saleItem)
				await this.savePos('draft');
			}

			this.oneTimeDiscountModal = false
		},
		oneTimeDiscountClickHandler() {
			this.oneTimeDiscountModal = true
		},
		searchTextChanged() {
			this.isSearchTxtChanged = true
		},
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		makeTooltipForPrice(incomeDates) {
			let str = '';
			if (incomeDates) {
				incomeDates.forEach((date, index) => {
					str = str + date + (incomeDates.length - 1 == index ? ' ' : ', ');
				})
			}
			return str;
		},
		showBalanceItemsModal() {
			this.balanceItems.forEach(el => {
				if (!el.modal) {
					this.$refs.balanceItemsRef.show()
					el.modal = true
				}
			})
		},
		focusMyDiscount() {
			this.$refs.posDiscount.$refs.fixedRef.focus();
			this.$refs.posDiscount.$refs.percentageRef.focus();
		},
		focusMyOptomDiscount() {
			this.$refs.posOptomDiscount.$refs.fixedOptomRef.focus();
			this.$refs.posOptomDiscount.$refs.percentageOptomRef.focus();
		},

		commentForSuspend(value) {
			this.localComment = value;
		},
		async createDraftAndFocus() {
			await this.createPosDraft({}).then(res => {
				// if (res) {
				// 	let zetDate = res.data.zetReportStart.substring(0,2),
				// 		updateDate = res.data.updateDate.substring(0,2)
				// 	if (zetDate != updateDate) {
				// 		this.zetDateEnd = true
				// 	}
				// }
			});
			this.focusSearchBar();
		},
		changeSuspendActive(booleanValue) {
			this.suspendActive = booleanValue
			this.localComment = this.comment;
			if (booleanValue) {
				this.$vs.notify({
					title: 'Продажа №: ' + this.currentSaleSuspendNumber + ' выбрана',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		afterPromotionSum(item) {
			let promoparam;
			if (item.promotions) {
				for (let i = 0; i < item.promotions.length; i++) {
					if (item.promotions[i].type == "PUL") {
						promoparam = item.promotions[i].value
					}
				}
				return promoparam;
			}

		},

		afterPromotionPercentage(item) {
			let promoparam1;
			if (item.promotions) {
				for (let i = 0; i < item.promotions.length; i++) {
					if (item.promotions[i].type == "%") {
						promoparam1 = item.promotions[i].value
					}
				}
				return promoparam1;

			}
		},
		...mapActions('pos', [
			'getItemsForPos', 'getItemsForPosReturn', 'increaseCount', 'addToCartAction', 'setIncrementValue',
			'decreaseCount', 'deleteFromCartAction', 'saleFinish', 'createPosDraft',
			'editDraft', 'getLatestSuspends', 'suspendSale', 'setSaleItemForDiscountModal', 'setSusPendClient',
			'setErrorOccurNotHappen', 'editDraftOptom', 'fetchPosSearchItems', 'clearCartItems'
		]),
		...mapActions('references', [
			'loadPaymentMethods'
		]),
		...mapActions('clients', [
			'emptyObjectStore'
		]),
		...mapActions('zetReport', [
			'startSessionToDep', 'getCurrentXReport'
		]),
		getOutOfStockError() {
			let error = false;
			for (let item of this.getCartItems) {
				if (item.count > item.qty && !item._rowVariant) {
					error = true;
					break;
				}
			}
			return error;
		},
		getPriceChanged() {
			let payload = {
				boolean: false,
				indexes: []
			}
			for (let i = 0; i < this.getCartItems.length; i++) {
				if (this.getCartItems[i].priceChanged) {
					Vue.set(this.getCartItems[i], '_cellVariants', {priceUzs: 'warning'})
					payload.boolean = true;
					payload.indexes.push(i + 1);
				}
			}
			return payload;
		},
		multiplePayment() {
			if (this.getCartItems.length > 0) {
				if (this.tempForSale.action == 'OPTOM_SAVDO') {
					if (!this.tempForSale.contragentId) {
						this.$vs.notify({
							title: 'Пожалуйста выберите контрагента',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
				}
				let hasOutOfStockItem = this.getOutOfStockError();
				let booleanAndIndexes = this.getPriceChanged();
				if (hasOutOfStockItem) {
					this.$vs.notify({
						title: 'Пожалуйста, проверьте количество продуктов',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.focusSearchBar();
				} else if (booleanAndIndexes.boolean) {
					let stringIndexes = booleanAndIndexes.indexes.join(', ');
					this.$vs.notify({
						title: `Проверьте эти товары №: "${stringIndexes}"`,
						text: 'если цена была изменена, то удалите и добавьте снова',
						time: 6500,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				} else {
					this.openClicked = true;
					this.$refs.multiplePayRef.reorderAndAddCurrencies()
					this.$refs.multiPayModal.show()
				}
			} else {
				this.openClicked = false;
				this.$vs.notify({
					title: 'Пожалуйста, добавьте продукт',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.focusSearchBar();
			}
		},
		closeXreport() {
			this.xreport = false
			this.$refs.xreport.hide()

		},

		showConfirmEndSession() {
			this.confirmEndSession = true
		},
		openItemForDiscount(data, index) {

			if (data.item.customPromotion.discount) {
				if (data.item.customPromotion.promotionType == '%') {

					this.$refs.posDiscount.itemLocal.percentage = data.item.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.fixed = '';
				} else {

					this.$refs.posDiscount.itemLocal.fixed = data.item.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.percentage = '';
				}
			} else {
				this.$refs.posDiscount.itemLocal.fixed = '';
				this.$refs.posDiscount.itemLocal.percentage = '';
			}
			this.currentItemIndex = index;
			this.setSaleItemForDiscountModal(data);
			this.discountTForTitle = true;
			this.discountOpenModal = true;
		},
		openItemForDiscountGeneral() {
			if (this.customPromotion) {
				if (this.customPromotion.promotionType == '%') {
					this.$refs.posDiscount.itemLocal.percentage = this.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.fixed = '';
				} else {
					this.$refs.posDiscount.itemLocal.fixed = this.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.percentage = '';
				}
			} else if (this.getFromModalMemberCard.memberCardDiscount) {
				this.$refs.posDiscount.itemLocal.percentage = this.getFromModalMemberCard.memberCardDiscount;
				this.$refs.posDiscount.itemLocal.fixed = '';
			} else {
				this.$refs.posDiscount.itemLocal.fixed = '';
				this.$refs.posDiscount.itemLocal.percentage = '';
			}
			this.discountTForTitle = false
			this.discountOpenModal = true;
			this.setSaleItemForDiscountModal(this.discountTForTitle);

		},

		closeEmit(event) {
			this.discountOpenModal = event;
		},
		async saveOptomDiscount(event) {

			if (event.promotionType === "%") {
				this.discountOptom = event.discount + ' ' + "%"
			} else {
				this.discountOptom = event.discount + ' ' + "сум"
			}

			if (this.getCartItems.length !== 0) {
				this.getCartItems.forEach((item, index) => {
					let obj = {}

					if (event.promotionType === "%") {
						obj.promotionType = "%";
						obj.discount = event.discount;
						obj.saleId = this.currentSaleId;
					} else {
						obj.promotionType = 'PUL';
						obj.discount = event.discount;
						obj.saleId = this.currentSaleId;

					}

					let payload = {
						index: index,
						obj: obj
					}
					this.setOptomPromotion(payload)
				})
				this.savePos('draft')
			}

			if (event.setToNull) {
				this.discountOptom = null
			}
			await this.editDraft(this.tempForSale);
			this.discountOptomOpenModal = false

		},
		async setOptomPromotion(payload) {
			await this.$store.commit('pos/setCustomPromotionForItem', payload);

		},

		closeOptomDiscount(event) {
			this.discountOptomOpenModal = event;
		},
		openModalForOptomDiscount() {
			this.discountOptomOpenModal = true
		},
		async closeAndPrintZReport(okEvent) {
			okEvent.preventDefault();

			await this.getCurrentXReport(localStorage.getItem('dep_id'))

			let resFromFBox = null;
			let errMsgFromFBox = null;
			try {
				resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
					ipAddress: localStorage.getItem('ip_address'),
					data: this.currentReport.payments,
					closeZReport: true,
					salesEur: this.currentReport.salesEuro,
					totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
				});
			} catch (e) {
				if (e.request && e.request.response) {
					let response = JSON.parse(e.request.response);
					errMsgFromFBox = response.message;
				}
			}

			if (resFromFBox && resFromFBox.data.is_success) {
				this.confirmEndSession = false
				this.zreport = true
				this.$refs.zreport.show()
			} else {
				let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
				this.$vs.notify({
					title: fbError,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		showZReport() {
			this.confirmEndSession = false
			this.zreport = true
			this.$refs.zreport.show()
		},
		showXReport() {
			this.xreport = true
			this.$refs.xreport.show()
		},
		closeZreport() {
			this.zreport = false
			this.$refs.zreport.hide()
			this.$router.go()
			if (this.isCashier) {
				this.$store.dispatch('logout')
			}
		},
		closePayment() {
			this.openClicked = false;
			this.$refs.multiPayModal.hide()
		},
		minimizePayment() {
			this.openClicked = false;
			this.$refs.multiPayModal.hide()
		},
		savdoTypeChanged($event) {
			this.changeDefaultValueToOptomAndDona()
			if ($event.type === 'isOptom') {
				this.tempForSale.action = 'OPTOM_SAVDO';
				this.tempForSale.contragentId = $event.cont ? $event.cont.id : null;
			} else {
				this.tempForSale.action = 'SOTISH';
				delete this.tempForSale.contragentId
			}
			this.focusSearchBar();
			this.clearSearchBar();
			this.tempForSale.customPromotion = this.customPromotion;
			this.tempForSale.saleItems = this.getCartItems;
			this.editDraftOptom(this.tempForSale);
			this.savdoType = $event.type
		},
		changeDefaultValueToOptomAndDona() {
			this.discountOptom = null
		},

		async successMultiPay(isCheck, paymentMethods, totalPaid, debtPaymentAmount, returnItemsCount, returnItemsSum, sponsorshipAmount) {
			this.returnMoney = 0;
			this.returnItemsCount = returnItemsCount;
			this.returnItemsSum = returnItemsSum;
			this.sponsorshipAmount = sponsorshipAmount;
			this.totalPaid = totalPaid;
			this.multiPays = paymentMethods;
			this.debtPayment = debtPaymentAmount;
			await this.savePos('ready');
			if (this.saleFinishError) {
				this.$store.commit('pos/setPosDisabled', false);
				return 0;
			} else {
				await this.makeCurrentDateTime();
				this.$refs.multiPayModal.hide()
				this.openClicked = false;
				if (isCheck) {
					let vm = this;
					setTimeout(async function () {
						await vm.removePageSizeStyle();
						await vm.setPageSizeStyle('portrait');
						window.print();
						/** RESET STATE **/
						vm.$store.commit('pos/resetState');
						vm.$store.commit('pos/setSellerName', '');
						vm.$store.commit('pos/setSellerName', '');
						// vm.$store.commit('pos/setSellerId', null);
						// vm.$refs.clientForPos.seller = null;
						vm.$store.commit('certificates/setCertificateForPos', null);
						vm.$store.dispatch('pos/createPosDraft', {});
						vm.$store.commit('pos/resetSuspendId');
						vm.suspendActive = false;
						vm.$store.commit('pos/clearOnlaynProdaja')
						vm.$refs.clientForPos.flight = ''
						vm.$refs.clientForPos.ticket = ''
					}, 1000);
				} else {
					/** RESET STATE **/
					this.$store.commit('pos/resetState');
					this.$store.commit('pos/setSellerName', '');
					// this.$refs.clientForPos.seller = null;
					this.$store.commit('certificates/setCertificateForPos', null);
					// this.$store.commit('pos/setSellerId', null);
					this.$store.dispatch('pos/createPosDraft', {});
					this.$store.commit('pos/resetSuspendId');
					this.suspendActive = false;
					this.$store.commit('pos/clearOnlaynProdaja')
					this.$refs.clientForPos.flight = ''
					this.$refs.clientForPos.ticket = ''
				}

				this.$store.commit('pos/setPosDisabled', false);
				await this.focusSearchBar();
				await this.getActiveDiscount();
			}
		},
		async saveSuspend() {
			if (this.getCartItems.length > 0) {
				await this.savePos('suspended');
				await this.$store.commit('pos/resetState');
				if (this.getCurrentClientFromModal) {
					this.setSusPendClient(this.getCurrentClientFromModal);
				}
				if (this.getFromModalMemberCard) {
					this.setSusPendClient(this.getFromModalMemberCard);
				}
				await this.$store.commit('clients/resetCurrentClient');
				await this.getLatestSuspends();
				if (this.currentSuspendId != null) {
					this.$store.commit('pos/resetSuspendId');
				}
				await this.createPosDraft({}).then(res => {
					// if (res) {
					// 	let zetDate = res.data.zetReportStart.substring(0,2),
					// 		updateDate = res.data.updateDate.substring(0,2)
					// 	if (zetDate != updateDate) {
					// 		this.zetDateEnd = true
					// 	}
					// }
				});
				this.localComment = '';
				await this.$vs.notify({
					title: 'Продажа №: ' + this.lastSuspendedSaleNumber + ' успешно сохранена',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.suspendActive = false;
				this.focusSearchBar();
				this.clearSearchBar();
			} else {
				this.$vs.notify({
					title: 'Пожалуйста, добавьте продукт',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.focusSearchBar()
			}

		},
		getCountOfItem(index) {
			return this.getCartItems[index].count > 0 ? this.getCartItems[index].count : -this.getCartItems[index].count;
		},
		setOnlaynProdajaParams() {
			this.tempForSale.orderNumber = parseFloat(this.orderNumber);
			this.tempForSale.clientName = this.clientName;
			this.tempForSale.clientPhoneNumber = this.clientPhoneNumber;
			this.tempForSale.clientAddress = this.clientAddress;
		},
		async savePos(status, fromDelete = false) {
			this.discountOpenModal = false;
			if (this.getFromModalMemberCard) {
				this.tempForSale.customerId = this.getFromModalMemberCard.id;
			} else if (this.getCurrentClient) {
				this.tempForSale.customerId = this.getCurrentClient.id;
			} else if (this.getCurrentClientFromModal) {
				this.tempForSale.customerId = this.getCurrentClientFromModal.id;
			} else {
				this.tempForSale.customerId = null;
			}

			this.tempForSale.saleNumber = this.currentSuspendId ? this.currentSaleSuspendNumber : this.currentSaleNumber;
			this.tempForSale.id = this.currentSuspendId ? this.currentSuspendId : this.currentSaleId;

			this.tempForSale.comment = this.localComment;
			this.tempForSale.saleDate = this.makeCurrentDateTime('savePos')

			this.tempForSale.cashboxNumber = localStorage.getItem('cash_number');
			this.tempForSale.cashboxId = localStorage.getItem('cash_id');
			// this.tempForSale.amountOfPaymentUzs = this.realTotalSum;
			// this.tempForSale.amountOfAfterPromoUzs = this.finalTotalSum;
			this.tempForSale.customPromotion = this.customPromotion;
			this.tempForSale.cashierFullName = this.cashierFullName;
			this.tempForSale.sellerId = this.sellerId;
			this.tempForSale.saleItems = this.getCartItems;
			this.tempForSale.amountOfPaymentUzs = this.amountOfPaymentUzs;
			this.tempForSale.amountOfAfterPromoUzs = this.amountOfAfterPromoUzs;
			this.tempForSale.finalTotalSum = this.finalTotalSum;
			this.tempForSale.realTotalSum = this.amountOfPaymentUzs;
			this.tempForSale.flight = this.$refs.clientForPos.flight
			this.tempForSale.ticket = this.$refs.clientForPos.ticket
			this.tempForSale.currencyRateDtos = this.lastCurrencyRates
			if (status == 'draft') {
				this.tempForSale.saleItems.forEach(el => {
					el.isOptom = false
				})
				this.itemSelectedWithEnter = false;
				await this.$store.commit("pos/editPosSaleLocally", {saleDoc: this.tempForSale, fromDelete: fromDelete});
				this.tempForSale.amountOfPaymentUzs = this.amountOfPaymentUzs;
				this.tempForSale.amountOfAfterPromoUzs = this.amountOfAfterPromoUzs;
				this.tempForSale.finalTotalSum = this.finalTotalSum;
				this.tempForSale.realTotalSum = this.amountOfPaymentUzs;
				// await this.editDraft(this.tempForSale);
			}
			if (this.multiPays) {
				this.tempForSale.payments = this.multiPays
			}
			if (status == 'ready') {
				let fbError = null
				if (this.getCartItems.length > 0) {
					if (this.isOnlaynProdaja) {
						await this.setOnlaynProdajaParams()
					}
					let msgInError = null
					await ApiService.post('sale/get/soliq/order-create', this.tempForSale)
						.then(res => {
						})
						.catch(e => {
							if (e.response.data.selfCode == 800) {
								this.saleErrorMessage = e.response.data.message
								this.saleError = true
							}
							let response = JSON.parse(e.request.response);
							msgInError = JSON.parse(response.message)
						})
					if (msgInError) {
						let resFromFBox = null
						let errMsgFromFBox = null
						try {
							resFromFBox = await FBoxService.orderCreate(localStorage.getItem('ip_address'), msgInError)
						} catch (e) {
							if (e.request && e.request.response) {
								let response = JSON.parse(e.request.response);
								errMsgFromFBox = response.message
							}
						}
						// let resFromFBox = await FBoxService.orderCreate(TokenService.getCashBoxIpAddress(), msgInError)
						if (resFromFBox && resFromFBox.data.is_success) {
							await this.saleFinish(this.tempForSale);
							if (!this.saleFinishError) {
								this.$vs.notify({
									time: 1000,
									title: 'Продажа выполнена успешно!',
									color: 'success',
									icon: 'close',
									position: 'top-right'
								});
								this.$store.commit('pos/setIsReturn', false);
								await this.focusSearchBar();

							}
						} else {
							this.$store.commit('pos/setPosDisabled', false);
							fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'ERROR: Please, try again')
							this.$vs.notify({
								title: fbError,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
							this.$store.commit('pos/setSaleFinishError', {message: fbError, boolean: true});
						}
					}
				} else {
					this.$vs.notify({
						title: 'Пожалуйста, добавьте продукт',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
				await this.clearSearchBar();
				await this.focusSearchBar();
			} else if (status == 'suspended') {
				await this.suspendSale(this.tempForSale);
				this.$refs.clientForPos.flight = ''
				this.$refs.clientForPos.ticket = ''
			}
		},
		makeCurrentDateTime(forMethod) {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = '0' + month;
			}
			if (day.toString().length == 1) {
				day = '0' + day;
			}
			if (hour.toString().length == 1) {
				hour = '0' + hour;
			}
			if (minute.toString().length == 1) {
				minute = '0' + minute;
			}
			if (second.toString().length == 1) {
				second = '0' + second;
			}
			if (forMethod == 'savePos') {
				return month + '-' + day + '-' + year;
			}
			this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
		},
		cancelClicked() {
			this.$store.commit('pos/resetState');
			const emptyObject = {};
			this.emptyObjectStore(emptyObject);
			this.focusSearchBar();
			this.clearSearchBar();
		},
		async selectedHandler(selectedIndex) {
			if (this.isSearchTxtChanged) {
				await this.filterChanged(this.posSearchValue)
				return;
			}
			this.currentIndex = selectedIndex;
			if (this.getItems.length > 0) {
				this.itemSelectedWithEnter = true;
				let equalItems = this.getItems.filter(el => el.itemId == this.getItems[selectedIndex].itemId && el.termOfItem == this.getItems[selectedIndex].termOfItem);
				let foundDifference = false;
				if (equalItems.length > 1) {
					equalItems.forEach(el => {
						if (el.priceUzs != this.getItems[selectedIndex].priceUzs) {
							foundDifference = true;
						}
					})
					if (foundDifference) {
						this.$vs.notify({
							title: 'Этот товар имеет разные цены',
							text: 'Пожалуйста, выровняйте цены',
							time: 3500,
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						setTimeout(() => {
							this.itemSelectedWithEnter = false;
						}, 500)
						return 0;
					}
				}
				if (!this.getItems[selectedIndex].priceUzs || this.getItems[selectedIndex].priceUzs <= 0) {
					this.$vs.notify({
						title: 'Bu mahsulot narxlanmagan',
						text: 'Itimos, narxlang',
						time: 3500,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					setTimeout(() => {
						this.itemSelectedWithEnter = false;
					}, 500)
					return 0;
				}
				if ((this.getItems[selectedIndex].qty > 0 && this.getItems[selectedIndex].priceUzs > 0) || this.isReturn) {
					this.selectedItem = this.getItems[selectedIndex];
					if (this.selectedItem.multiBarcode == '') {
						this.selectedItem.multiBarcode = null;
					}
					this.itemSelectedWithEnter = false;
					let foundIndex = (this.getCartItems.findIndex(el => {
						return el.itemId == this.selectedItem.itemId && el.termOfItem == this.selectedItem.termOfItem;
					}));
					if (foundIndex != -1 || this.selectedItem.multiBarcode != null || this.selectedItem.multiBarcodes.length == 0) {
						await this.addToCart(this.selectedItem);
					} else
						this.multiBarcodeModalShow = true;
				}
			} else {
				/*await this.hideSearchResult();
				await this.clearSearchBar();*/
			}

		},
		async selectMultiBarcode(multiBarcode) {
			this.multiBarcode = multiBarcode;
			this.selectedItem.multiBarcode = multiBarcode;
			await this.addToCart(this.selectedItem);
			this.multiBarcodeModalShow = false;
		},
		escapeClicked() {
			this.hideSearchResult();
			this.clearSearchBar();
			this.focusSearchBar();
		},
		async setCount(event, index) {
			let inputCount = parseFloat(event)
			if (!inputCount) {
				let payload = {};
				payload.index = index;
				payload.newCount = 1;
				await this.setIncrementValue(payload);
			} else {
				if (inputCount > 0) {
					let payload = {};
					payload.index = index;
					payload.newCount = inputCount;
					await this.setIncrementValue(payload);
				} else {
					let payload = {};
					payload.index = index;
					payload.newCount = 1;
					await this.setIncrementValue(payload);
				}
			}
			await this.savePos('draft');
		},
		async addToCart(item) {
			this.hideSearchResult();
			this.clearSearchBar();
			this.focusSearchBar();
			await this.addToCartAction(item);
			this.barcodeScanned = false;
			await this.savePos('draft');
		},
		async deleteFromCart(index) {
			await this.deleteFromCartAction(index);
			await this.savePos('draft', true);
			this.focusSearchBar();
		},
		async decreaseQty(dataDecrease) {
			this.isCountBtnsDisabled = true;
			await this.decreaseCount(dataDecrease);
			await this.savePos('draft');
			this.isCountBtnsDisabled = false;
			this.focusSearchBar();
		},
		async increaseQty(dataindex) {
			this.isCountBtnsDisabled = true;
			await this.increaseCount(dataindex);
			await this.savePos('draft');
			this.isCountBtnsDisabled = false;
			this.focusSearchBar();
		},
		async filterChanged(newVal) {
			this.isSearchTxtChanged = false
			if (!this.itemSelectedWithEnter) {
				this.currentIndex = 0;
				if (this.$refs.withKeyboardControl) {
					this.$refs.withKeyboardControl.selectedIndex = 0;
				}
				if (newVal.length >= 2) {
					/** BU RESULT TOPILMASA SEARCHINPUT VALUENI SELECT QILIB QO'YISHNI TO'G'IRLASH UCHUN YOZILGAN **/
					clearTimeout(this.timeout);
					let vm = this;
					this.timeout = setTimeout(async function () {
						vm.showSearchResult();
						if (!vm.barcodeScanned) {
							await vm.fetchPosSearchItems(newVal);
							// await vm.getItemsForPos(newVal);
						}
						// await vm.showSearchResult();
					}, 5);
					// this.showSearchResult();
					// await this.getItemsForPos(newVal);
					/*if (this.getItems.length == 1) {
						this.hideSearchResult();
						await this.selectedHandler(0)
					} else {
						this.showSearchResult();
					}*/
				} else {
					this.hideSearchResult();
				}
			}

		},
		async posBarcodeScanned(barcodeNumber) {
			if (barcodeNumber.length > 3) {
				this.barcodeScanned = true;
				if (this.getItems.length <= 0) {
					await this.fetchPosSearchItems(barcodeNumber);
					// await this.getItemsForPos(barcodeNumber);
				}
				if (this.getItems.length > 0) {
					if (this.getItems[0].qty > 0 || this.isReturn) {
						await this.selectedHandler(0)
						// await this.addToCart(this.getItems[0]);
					}
				} else {
					await this.setBarcodeScanned(false);
				}
			}
		},
		setBarcodeScanned(boolean) {
			this.$refs.searchBar.focus();
			this.$refs.searchBar.select();
			this.barcodeScanned = boolean;
		},
		showSearchResult() {
			this.currentIndex = 0;
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.addKeyHandler();
			}
			this.$refs.searchResult.style.display = 'block'
		},
		hideSearchResult() {
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.removeKeyHandler();
			}
			this.$refs.searchResult ? this.$refs.searchResult.style.display = 'none' : ''
			this.$store.commit('pos/setPosItems', []);
		},
		focusSearchBar(fromChild = '') {
			this.$refs.searchBar.focus();
			// this.$refs.searchBar.$el.setSelectionRange(0, this.$refs.searchBar.$el.value.length);
			this.$refs.searchBar.$el.value = '';
			if (fromChild == 'clientForPos') {
				this.clearSearchBar();
			}
		},
		clearSearchBar() {
			this.posSearchValue = '';
			this.$refs.searchBar.$el.value = '';
		},
		searchBarRefresh() {
			this.clearSearchBar();
			this.focusSearchBar();
		},

		async showModalIfSessionNotStarted() {
			if (this.errorOccur) {
				this.$refs.sessionStart.show()
			}
		},
		async sessionStartOk() {
			this.setErrorOccurNotHappen()
			let resFromFBox = null
			let errMsgFromFBox = null
			try {
				resFromFBox = await FBoxService.zReportOpen(localStorage.getItem('ip_address'))
			} catch (e) {
				if (e.request && e.request.response) {
					let response = JSON.parse(e.request.response);
					errMsgFromFBox = response.message
				}
			}
			// AGAR FISCAL Z-REPORT NI MUVAFFAQIYATLI OCHSA SISTEMADA HAM OCHILADI
			if (resFromFBox && resFromFBox.data.is_success) {
				this.$refs.sessionStart.hide();
				await this.startSessionToDep(localStorage.getItem('dep_id'))
				await this.createPosDraft(this.tempForSale).then(res => {
					// if (res) {
					// 	let zetDate = res.data.zetReportStart.substring(0,2),
					// 		updateDate = res.data.updateDate.substring(0,2)
					// 	if (zetDate != updateDate) {
					// 		this.zetDateEnd = true
					// 	}
					// }
				});
				this.setErrorOccurNotHappen()
			} else {
				this.$set(this.sessionStart, 'code', null)
				this.sessionStart.codeState = null
				this.$set(this.sessionStart, 'codeState', null)
				this.focusEnterCode()

				let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
				this.$vs.notify({
					title: fbError,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},

		focusEnterCode() {
			this.$refs.enterConfirmCode.focus();
		}
	},

	/** --CREATED HOOK-- **/
	async created() {
		this.$barcodeScanner.init(this.posBarcodeScanned);
		await this.$store.commit('pos/resetState');
		await this.createPosDraft(this.tempForSale).then(res => {
			// if (res) {
			// 	let zetDate = res.data.zetReportStart.substring(0,2),
			// 		updateDate = res.data.updateDate.substring(0,2)
			// 	if (zetDate != updateDate) {
			// 		this.zetDateEnd = true
			// 	}
			// }
		});
		this.showModalIfSessionNotStarted()
		CurrencyService.fetchLastCurrencyRate()
			.then(res => {
				this.lastCurrencyRates = res.data
			})
			.catch(er => {
				console.log(er)
			})
	},

	/** --MOUNTED HOOK-- **/
	mounted() {
		this.focusSearchBar();
		this.cashboxNumber = localStorage.getItem('cash_number');
		this.getActiveDiscount()
	},

	/** --BEFORE DESTROY HOOK-- **/
	beforeDestroy() {
		clearInterval(this.$options.interval);
	},

	/** ROUTE GUARD **/
	beforeRouteEnter(to, from, next) {
		let cashboxnumber = window.localStorage.getItem('cashboxnumber');
		if (cashboxnumber) {
			next()
		} else {
			next('/point-of-sale/beforePos')
		}
	}
}
</script>

<style scoped lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Inconsolata");

::v-deep .modal-backdrop.show {
	opacity: 0.2 !important;
}

.print {
	display: none;
}

@media print {
	// @page {
	// 	size: portrait;
	// }
	.hidden-print {
		display: none !important;
	}
	.print {
		display: block;
		color: #000000;
	}
	.card {
		box-shadow: none;
	}
}

.posCustomModalHeader {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	.close {
		font-size: 14px;
	}
}

p {
	margin-bottom: 0;
}

.foundProduct {
	&.disabled {
		background-color: #eeeeee;
	}

	&.selected {
		background-color: #ccc;
	}
}

.input-group-text#for-barcode {
	padding: 0;

	.input-group-addon.barcode-refresh {
		padding: 0.575rem 0.75rem;

		&:active {
			border: 0.5px solid #dddddd;
		}
	}
}

.lastElemet {
	display: flex;
	justify-content: flex-end;
	margin-right: 25px;
}

#searchResult {
	display: none;
	position: absolute;
	top: 100%;
	width: 92.25%;
	border: 1px solid #c5c5c5;
	left: 4.05%;
	background: #ffffff;
	z-index: 101;
	max-height: 29rem;
	min-height: 80px;
	overflow-x: auto;

	.posItemImage {
		width: 40px;
		height: auto;
		object-fit: cover;
		margin: 0 10px 0 5px;
	}

	.foundProduct {
		padding: 10px;
		cursor: pointer;

		&:hover {
			background: #ccc;
		}

		.productName {
			padding-right: 1rem;
			font-size: 12px;
		}

		.productPrice {
			font-size: 13px;
			width: 32%;
		}

		.productBreadcrumb {
			font-size: 12px;
			color: #888;
		}
	}
}

@media (min-width: 1624px) {
	#searchResult {
		width: 93.495%;
		left: 3.41%;
	}
}

#posProducts {
	margin-top: 20px;
	max-height: 24rem;
	overflow-x: auto;
}

#overallAndButtons {
	.posFooterTable {
		.d-inline-table {
			display: inline-table;
		}
	}

	#posButtons {
		padding-top: 10px;
		padding-bottom: 10px;
		display: flex;
		justify-content: space-between;
	}
}

.alignedLeft {
	text-align: left;
}

.alignedRight {
	text-align: right;
}

.alignedCenter {
	text-align: center;
}

#posCheckClone {
	width: 100mm;
	background: white;
	padding: 10px;
	font-family: monospace;
	font-size: 14px;
	font-weight: bold;
	color: #000000 !important;

	#depNameClone {
		font-size: 18px;
	}

	.alignedCenter {
		text-align: center;
	}

	.alignedLeft {
		text-align: left;
	}

	.alignedRight {
		text-align: right;
	}

	.bottom-bordered {
		padding-bottom: 2px;
		border-bottom: 0.5px dashed #444;
	}

	table {
		width: 100%;
	}

	.returnItemBordered {
		border: 0.5px dotted black;
	}

	td,
	th {
		border: none;
		font-size: 12px;
		padding: 2px;
		color: #000000;
		vertical-align: top !important;

		&.alignedCenter {
			text-align: center;
		}

		&.alignedLeft {
			text-align: left;
		}

		&.alignedRight {
			text-align: right;
		}
	}

	.table {
		td,
		th {
			vertical-align: top;
		}
	}

	.posCheckTotal {
		table {
			td {
				font-weight: bold;
				font-size: 14px;
			}
		}
	}

	.posCheckTotalB {
		table {
			td {
				font-weight: bold;
				font-size: 12px;
			}
		}
	}

	.posThanks {
		p {
			text-align: center;
			font-weight: bold;
			font-size: 14px;
		}
	}
}
</style>
